import styled from 'styled-components'

export const Container = styled.section`
    float: left;
    width: 100%;
    position: relative;
    padding: 60px;
    background: url(${props => props.bgDesktop }) center center no-repeat;
    background-size: cover;
    display: flex;
    justify-content: center;

    @media only screen and (max-width: 1400px) {
        padding: 30px 20px;
    }
    
`

export const ContainerInterno = styled.div`
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    max-width: 1436px;
    width: 100%;

    @media only screen and (max-width: 1400px) {
        flex-direction: column;
        justify-content: space-between;
    }
`

export const BoxCol6 = styled.div`
    width: 66.6666%;
    padding: 0 15px;
    text-align: center;

    @media only screen and (max-width: 1400px) {
        width: 100%;
        padding: 0;
    }
`

export const TagContador = styled.div`
    float: left;
    width: 100%;
    padding: 10px 20px;
    background-color: #EDC748;
    border-radius: 10px 10px 0 0;

    span {
        text-align: center;
        float: left;
        width: 100%;
        color: #0C0C0F;
        font-weight: 900;
        font-size: 15px;
        line-height: 22px;

        @media only screen and (max-width: 500px) {
            font-size: 14px;
            line-height: 22px;

            br {
                display: none;
            }
        }
    }
    
`

export const TituloBanner = styled.span`
    float: left;
    width: 100%;
    color: #fff;
    font-size: 26px;
    line-height: 38px;
    font-weight: 600;
    text-align: left;
    margin-top: 30px;
    text-transform: uppercase;

    strong {
        color: #EDC748;
        font-weight: 900;
    }

    @media only screen and (max-width: 1400px) {
        text-align: center;

        br {
            display: none;
        }
    }

    @media only screen and (max-width: 500px) {
        font-size: 22px;
        line-height: 32px;
    }
`

export const TextoBanner = styled.span`
    float: left;
    width: 100%;
    color: #C3C9E6;
    font-size: 16px;
    line-height: 26px;
    font-weight: 500;
    text-align: left;
    margin-top: 30px;

    strong {
        color: #fff;
        font-weight: 900;
    }

    @media only screen and (max-width: 1400px) {
        text-align: center;

        br {
            display: none;
        }
    }

`

export const Imagem = styled.img`
    display: inline-block;
    max-width: 100%;

    @media only screen and (max-width: 1400px) {
        margin-top: 40px;
    }

`

export const TituloNaoSejaDemitido = styled.span `
    float: left;
    width: 100%;
    color: #fff;
    font-size: 18px;
    line-height: 28px;
    font-weight: 600;
    margin: 20px 0 20px 0;

    strong {
        color: #DCB84C;
    }

    @media only screen and (max-width: 500px) {
        font-size: 16px;
        line-height: 24px;
        margin: 10px 0;

        br {
            display: none;
        }

    }
    
`

export const LegendaNaoSejaDemitido = styled.span `
    float: left;
    width: 100%;
    color: #fff;
    font-size: 12px;
    font-weight: 600;
`